import React, { Suspense, useState, useEffect } from "react";
import Loading from "../Scenes/Components/Loading";
import { useSelector, useDispatch } from "react-redux";
import ToastMessage from "../Scenes/Components/ToastMessage";
import AlertMessage from "../Scenes/Components/AlertMessage";
import { addStyle, changeStyle, setPageDetails } from "../helpers";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import "./styles.css";
import "react-datepicker/dist/react-datepicker.css";

import { Routing, Routing1 } from "../Utils";
import UnableToLoadData from "../Scenes/Components/UnableToLoadData";
import PrivateRoute from "./PrivateRoute";
import NonPrivateRoute from "./NonPrivateRoute";

const Main = () => {
  const { user_details } = useSelector((state) => state.authReducer);
  const { loading } = useSelector((state) => state.loaderReducer);
  useEffect(() => {
    setPageDetails({
      title: "GoGmGO",
    });
  }, []);
  useEffect(() => {
    const cssUrl =
      user_details && user_details !== null
        ? `/CSS/style.css?v=2`
        : `/CSS/auth.css?v=2`;
    changeStyle(cssUrl);
    const prevCssUrl =
      user_details && user_details !== null ? `/CSS/styleMain.css?v=2` : ``;
    changeStyle(prevCssUrl, "prev-style-sheet");
  }, [user_details]);
  return (
    <Suspense fallback={<></>}>
      <Loading show={loading} />
      <ToastMessage />
      <AlertMessage />
      <BrowserRouter>
        <Switch>
          {[...Routing1].map((route, key) => {
            return (
              <NonPrivateRoute
                key={key}
                exact
                path={route.path}
                component={route.component}
              />
            );
          })}
          {[...Routing].map((route, key) => {
            return (
              <PrivateRoute
                key={key}
                exact
                path={route.path}
                component={route.component}
              />
            );
          })}
          <Route component={UnableToLoadData} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
};
export default Main;
